import React, { useState } from "react";
import {
	Box,
	Typography,
	TextField,
	Button,
	Grid,
	Checkbox,
	FormControlLabel,
	IconButton,
	Card,
	CardContent,
} from "@mui/material";
import FlightInfo from "../FlightInfo/FlightInfo";
import { BasicModal } from "../BasicModal/BasicModal";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import AddIcon from "@mui/icons-material/Add";
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";
import TrainIcon from "@mui/icons-material/Train";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import SaveIcon from "@mui/icons-material/Save";
import { useWindowSize } from "@uidotdev/usehooks";

const defaultData = [
	{
		departureAirport: "",
		departureDay: "",
		departureTime: "",
		duration: "",
		arrivalDay: "",
		arrivalTime: "",
		arrivalAirport: "",
		hasStopover: false,
		stopoverDuration: "",
		type: "flight",
	},
];

const Flight = ({ page, updatePage, textColor }) => {
	/*const [flightDataSets, setFlightDataSets] = useState(
		[] /*[
		{
			departureAirport: "BCN",
			departureDay: "13 Diciembre",
			departureTime: "20.00h",
			duration: "7:00h",
			arrivalDay: "14 Diciembre",
			arrivalTime: "8:00h",
			arrivalAirport: "DBX",
			hasStopover: true,
			stopoverDuration: "2:00h",
		},
		{
			departureAirport: "DBX",
			departureDay: "15 Diciembre",
			departureTime: "8.00h",
			duration: "4:00h",
			arrivalDay: "15 Diciembre",
			arrivalTime: "8:00h",
			arrivalAirport: "MALE",
			hasStopover: false,
			stopoverDuration: null,
		},
	])*/

	const [isModalOpen, setModalOpen] = useState(false);
	const [editedFlightData, setEditedFlightData] = useState(null);

	const handleOpenModal = () => {
		setModalOpen(true);
		const existingTransport = page.transport ?? [];
		setEditedFlightData(
			existingTransport.length > 0 ? [...existingTransport] : [],
		);
	};

	const handleCloseModal = () => {
		setModalOpen(false);
	};

	const handleSaveFlightData = () => {
		const transportData = Array.isArray(editedFlightData)
			? editedFlightData
			: [];
		updatePage({ transport: transportData });
		handleCloseModal();
	};

	const handleAddFlightData = (type) => {
		const newEntry = { ...defaultData[0], type };
		setEditedFlightData((prevData) => {
			const currentData = Array.isArray(prevData) ? prevData : [];
			return [...currentData, newEntry];
		});
	};

	const handleRemoveFlightData = (index) => {
		setEditedFlightData((prevData) => {
			const currentData = Array.isArray(prevData) ? prevData : [];
			const newData = [...currentData];
			newData.splice(index, 1);
			return newData;
		});
	};

	const size = useWindowSize();

	return (
		<div className="template-item" data-template-item>
			{/*flightDataSets.map((flight, index) => (
				<div key={index}>
					<FlightInfo flightData={flight} />
					<Button variant="outlined" onClick={() => handleOpenModal(index)}>
						Editar Vuelo {index + 1}
					</Button>
				</div>
            ))*/}

			{(page.transport ?? []).length > 0 && (
				<FlightInfo
					flightData={page.transport ?? []}
					handleOpenModal={handleOpenModal}
					textColor={textColor}
				/>
			)}
			{(page.transport ?? []).length === 0 && (
				<Card
					className="template-item"
					data-template-item
					elevation={0}
					onMouseDown={(e) => {
						e.stopPropagation();
					}}
					onClick={(e) => {
						e.stopPropagation();
					}}
					sx={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "center",
						alignItems: "center",
						minHeight: 300,
						backgroundColor: "#F8FAFC",
						marginBottom: 0,
						border: "2px dashed rgba(99, 102, 241, 0.25)",
						boxShadow: "none",
						borderRadius: "20px",
						transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
						"&:hover": {
							borderColor: "rgba(99, 102, 241, 0.5)",
							backgroundColor: "rgba(99, 102, 241, 0.04)",
							boxShadow: "0 4px 16px rgba(99, 102, 241, 0.12)",
						},
						position: "relative",
						zIndex: 1001,
						pointerEvents: "auto",
					}}
				>
					<CardContent
						className="template-item"
						data-template-item
						sx={{
							display: "flex",
							flexDirection: "column",
							alignItems: "center",
							gap: 1,
							textAlign: "center",
							pointerEvents: "auto",
							padding: 3,
							"&:last-child": {
								paddingBottom: 3,
							},
						}}
					>
						<FlightTakeoffIcon
							className="template-item"
							data-template-item
							sx={{
								fontSize: 64,
								color: "#6366F1",
								opacity: 0.5,
							}}
						/>
						<Typography
							className="template-item"
							data-template-item
							variant="h6"
							sx={{
								color: "#1a1a2e",
								fontWeight: 700,
								fontSize: "1rem",
							}}
						>
							No hay transporte añadido
						</Typography>
						<Typography
							className="template-item"
							data-template-item
							variant="body2"
							sx={{
								color: "#4B5563",
								mb: 2,
								fontSize: "0.75rem",
							}}
						>
							Añade información sobre vuelos, trenes o coches
						</Typography>
						<Button
							className="template-item"
							data-template-item
							startIcon={<AddIcon />}
							variant="contained"
							onMouseDown={(e) => {
								e.stopPropagation();
								e.preventDefault();
							}}
							onClick={(e) => {
								e.stopPropagation();
								e.preventDefault();
								handleOpenModal(null);
							}}
							sx={{
								background: "linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
								color: "white !important",
								textTransform: "none",
								fontWeight: 600,
								borderRadius: "12px",
								border: "none !important",
								padding: "6px 12px",
								boxShadow: "0 4px 16px rgba(99, 102, 241, 0.35)",
								"&:hover": {
									background:
										"linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
									boxShadow: "0 6px 20px rgba(99, 102, 241, 0.45)",
									transform: "translateY(-2px)",
								},
								fontSize: "0.75rem",
								position: "relative",
								zIndex: 10001,
								pointerEvents: "auto",
							}}
						>
							Añadir Transporte
						</Button>
					</CardContent>
				</Card>
			)}

			<BasicModal
				width={700}
				showModal={isModalOpen}
				handleClose={handleCloseModal}
				children={
					<Box sx={{ padding: { xs: 2, sm: 3 } }}>
						<Box sx={{ mb: { xs: 3, sm: 4 } }}>
							<Typography
								variant="h5"
								sx={{
									fontWeight: 700,
									color: "#1a1a2e",
									mb: 1,
									fontSize: { xs: "1.25rem", sm: "1.5rem" },
								}}
							>
								{page.transport.length === 0
									? "Información del transporte"
									: page.transport[0]?.type === "flight"
										? "Información del vuelo"
										: page.transport[0]?.type === "train"
											? "Información del tren"
											: "Información del transporte"}
							</Typography>
							<Typography
								variant="body2"
								sx={{
									color: "#4B5563",
									fontSize: { xs: "0.875rem", sm: "0.95rem" },
								}}
							>
								{page.transport.length === 0
									? "Añade los detalles de tu transporte"
									: "Edita los detalles de tu transporte"}
							</Typography>
						</Box>

						{editedFlightData &&
							editedFlightData.map((flightData, index) => (
								<Card
									key={index}
									elevation={0}
									sx={{
										mb: 3,
										border: "1px solid rgba(0, 0, 0, 0.06)",
										borderRadius: "20px",
										position: "relative",
										boxShadow: "0 4px 16px rgba(0, 0, 0, 0.08)",
										transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
										"&:hover": {
											boxShadow: "0 8px 24px rgba(0, 0, 0, 0.1)",
										},
									}}
								>
									<CardContent sx={{ padding: { xs: 2, sm: 3 } }}>
										<Box
											sx={{
												display: "flex",
												justifyContent: "space-between",
												alignItems: "center",
												mb: 2,
												flexWrap: "wrap",
												gap: 1,
											}}
										>
											<Typography
												variant="h6"
												sx={{
													fontWeight: 700,
													color: "#1a1a2e",
													display: "flex",
													alignItems: "center",
													gap: 1,
													fontSize: { xs: "1rem", sm: "1.25rem" },
												}}
											>
												{flightData.type === "flight" && (
													<FlightTakeoffIcon sx={{ color: "#6366F1" }} />
												)}
												{flightData.type === "train" && (
													<TrainIcon sx={{ color: "#6366F1" }} />
												)}
												{flightData.type === "car" && (
													<DirectionsCarIcon sx={{ color: "#6366F1" }} />
												)}
												{flightData.type === "flight"
													? "Vuelo"
													: flightData.type === "train"
														? "Tren"
														: "Coche/Autobús"}{" "}
												{index + 1}
											</Typography>
											<IconButton
												onClick={() => handleRemoveFlightData(index)}
												sx={{
													color: "#F43F5E",
													"&:hover": {
														backgroundColor: "rgba(244, 63, 94, 0.1)",
													},
												}}
											>
												<DeleteForeverIcon />
											</IconButton>
										</Box>

										<Grid container spacing={{ xs: 1.5, sm: 2 }}>
											<Grid item xs={12} sm={6} md={4}>
												<Typography
													variant="body2"
													sx={{
														fontSize: "0.75rem",
														fontWeight: 600,
														color: "#4B5563",
														mb: 1,
														textTransform: "uppercase",
														letterSpacing: 0.5,
													}}
												>
													{flightData.type === "flight"
														? "Aeropuerto de Salida"
														: "Lugar de Salida"}
												</Typography>
												<TextField
													fullWidth
													value={flightData.departureAirport}
													placeholder={
														flightData.type === "flight"
															? "Ej: BCN"
															: "Ej: Estación Central"
													}
													onChange={(e) => {
														const auxFlightData = { ...flightData };
														auxFlightData.departureAirport = e.target.value;
														const auxEditedFlightData = [...editedFlightData];
														auxEditedFlightData[index] = auxFlightData;
														setEditedFlightData(auxEditedFlightData);
													}}
													sx={{
														"& .MuiOutlinedInput-root": {
															borderRadius: "12px",
														},
													}}
												/>
											</Grid>
											<Grid item xs={12} sm={6} md={4}>
												<Typography
													variant="body2"
													sx={{
														fontSize: "0.75rem",
														fontWeight: 600,
														color: "#4B5563",
														mb: 1,
														textTransform: "uppercase",
														letterSpacing: 0.5,
													}}
												>
													Día de Salida
												</Typography>
												<TextField
													fullWidth
													value={flightData.departureDay}
													placeholder="Ej: 13 Diciembre"
													onChange={(e) => {
														const auxFlightData = { ...flightData };
														auxFlightData.departureDay = e.target.value;
														const auxEditedFlightData = [...editedFlightData];
														auxEditedFlightData[index] = auxFlightData;
														setEditedFlightData(auxEditedFlightData);
													}}
													sx={{
														"& .MuiOutlinedInput-root": {
															borderRadius: "12px",
														},
													}}
												/>
											</Grid>
											<Grid item xs={12} sm={6} md={4}>
												<Typography
													variant="body2"
													sx={{
														fontSize: "0.75rem",
														fontWeight: 600,
														color: "#4B5563",
														mb: 1,
														textTransform: "uppercase",
														letterSpacing: 0.5,
													}}
												>
													Hora de Salida
												</Typography>
												<TextField
													fullWidth
													value={flightData.departureTime}
													placeholder="Ej: 20:00h"
													onChange={(e) => {
														const auxFlightData = { ...flightData };
														auxFlightData.departureTime = e.target.value;
														const auxEditedFlightData = [...editedFlightData];
														auxEditedFlightData[index] = auxFlightData;
														setEditedFlightData(auxEditedFlightData);
													}}
													sx={{
														"& .MuiOutlinedInput-root": {
															borderRadius: "12px",
														},
													}}
												/>
											</Grid>

											<Grid item xs={12} sm={6} md={4}>
												<Typography
													variant="body2"
													sx={{
														fontSize: "0.75rem",
														fontWeight: 600,
														color: "#4B5563",
														mb: 1,
														textTransform: "uppercase",
														letterSpacing: 0.5,
													}}
												>
													{flightData.type === "flight"
														? "Aeropuerto de Llegada"
														: "Lugar de Llegada"}
												</Typography>
												<TextField
													fullWidth
													value={flightData.arrivalAirport}
													placeholder={
														flightData.type === "flight"
															? "Ej: DBX"
															: "Ej: Estación Central"
													}
													onChange={(e) => {
														const auxFlightData = { ...flightData };
														auxFlightData.arrivalAirport = e.target.value;
														const auxEditedFlightData = [...editedFlightData];
														auxEditedFlightData[index] = auxFlightData;
														setEditedFlightData(auxEditedFlightData);
													}}
													sx={{
														"& .MuiOutlinedInput-root": {
															borderRadius: "12px",
														},
													}}
												/>
											</Grid>

											<Grid item xs={12} sm={6} md={4}>
												<Typography
													variant="body2"
													sx={{
														fontSize: "0.75rem",
														fontWeight: 600,
														color: "#4B5563",
														mb: 1,
														textTransform: "uppercase",
														letterSpacing: 0.5,
													}}
												>
													Día de Llegada
												</Typography>
												<TextField
													fullWidth
													value={flightData.arrivalDay}
													placeholder="Ej: 14 Diciembre"
													onChange={(e) => {
														const auxFlightData = { ...flightData };
														auxFlightData.arrivalDay = e.target.value;
														const auxEditedFlightData = [...editedFlightData];
														auxEditedFlightData[index] = auxFlightData;
														setEditedFlightData(auxEditedFlightData);
													}}
													sx={{
														"& .MuiOutlinedInput-root": {
															borderRadius: "12px",
														},
													}}
												/>
											</Grid>

											<Grid item xs={12} sm={6} md={4}>
												<Typography
													variant="body2"
													sx={{
														fontSize: "0.75rem",
														fontWeight: 600,
														color: "#4B5563",
														mb: 1,
														textTransform: "uppercase",
														letterSpacing: 0.5,
													}}
												>
													Hora de Llegada
												</Typography>
												<TextField
													fullWidth
													value={flightData.arrivalTime}
													placeholder="Ej: 8:00h"
													onChange={(e) => {
														const auxFlightData = { ...flightData };
														auxFlightData.arrivalTime = e.target.value;
														const auxEditedFlightData = [...editedFlightData];
														auxEditedFlightData[index] = auxFlightData;
														setEditedFlightData(auxEditedFlightData);
													}}
													sx={{
														"& .MuiOutlinedInput-root": {
															borderRadius: "12px",
														},
													}}
												/>
											</Grid>

											<Grid item xs={12} sm={6} md={4}>
												<Typography
													variant="body2"
													sx={{
														fontSize: "0.75rem",
														fontWeight: 600,
														color: "#4B5563",
														mb: 1,
														textTransform: "uppercase",
														letterSpacing: 0.5,
													}}
												>
													{flightData.type === "flight"
														? "Duración del vuelo"
														: "Duración del trayecto"}
												</Typography>
												<TextField
													fullWidth
													value={flightData.duration}
													placeholder="Ej: 7:00h"
													onChange={(e) => {
														const auxFlightData = { ...flightData };
														auxFlightData.duration = e.target.value;
														const auxEditedFlightData = [...editedFlightData];
														auxEditedFlightData[index] = auxFlightData;
														setEditedFlightData(auxEditedFlightData);
													}}
													sx={{
														"& .MuiOutlinedInput-root": {
															borderRadius: "12px",
														},
													}}
												/>
											</Grid>

											<Grid item xs={12} sm={6} md={6}>
												<FormControlLabel
													control={
														<Checkbox
															checked={flightData.hasStopover}
															onChange={(e) => {
																const auxFlightData = { ...flightData };
																auxFlightData.hasStopover =
																	!auxFlightData.hasStopover;
																const auxEditedFlightData = [
																	...editedFlightData,
																];
																auxEditedFlightData[index] = auxFlightData;
																setEditedFlightData(auxEditedFlightData);
															}}
															sx={{
																color: "#6366F1",
																"&.Mui-checked": {
																	color: "#6366F1",
																},
															}}
														/>
													}
													label={
														<Typography
															variant="body2"
															sx={{
																fontWeight: 600,
																color: "#1a1a2e",
															}}
														>
															{flightData.type === "flight"
																? "¿Tienes escala?"
																: "¿Tienes parada?"}
														</Typography>
													}
												/>
											</Grid>
											{flightData.hasStopover && (
												<Grid item xs={12} sm={6} md={6}>
													<Typography
														variant="body2"
														sx={{
															fontSize: "0.75rem",
															fontWeight: 600,
															color: "#4B5563",
															mb: 1,
															textTransform: "uppercase",
															letterSpacing: 0.5,
														}}
													>
														Duración de la conexión
													</Typography>
													<TextField
														fullWidth
														value={flightData.stopoverDuration}
														placeholder="Ej: 2:00h"
														onChange={(e) => {
															const auxFlightData = { ...flightData };
															auxFlightData.stopoverDuration = e.target.value;
															const auxEditedFlightData = [...editedFlightData];
															auxEditedFlightData[index] = auxFlightData;
															setEditedFlightData(auxEditedFlightData);
														}}
														sx={{
															"& .MuiOutlinedInput-root": {
																borderRadius: "12px",
															},
														}}
													/>
												</Grid>
											)}
										</Grid>
									</CardContent>
								</Card>
							))}
						{!editedFlightData || editedFlightData.length === 0 ? (
							<Box
								sx={{
									display: "flex",
									flexDirection: "column",
									alignItems: "center",
									justifyContent: "center",
									gap: 3,
									py: 4,
									px: { xs: 1, sm: 2 },
									borderRadius: "20px",
									border: "1px solid rgba(0, 0, 0, 0.06)",
									backgroundColor: "#F8FAFC",
									boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
								}}
							>
								<Typography
									variant="body1"
									sx={{
										color: "#4B5563",
										textAlign: "center",
										fontSize: { xs: "0.9375rem", sm: "1rem" },
										fontWeight: 500,
									}}
								>
									Selecciona el tipo de transporte que deseas añadir
								</Typography>
								<Box
									sx={{
										display: "flex",
										flexDirection: { xs: "column", sm: "row" },
										gap: { xs: 1.5, sm: 2 },
										justifyContent: "center",
										width: "100%",
										flexWrap: "wrap",
									}}
								>
									<Button
										variant="outlined"
										startIcon={<DirectionsCarIcon sx={{ color: "#6366F1" }} />}
										onClick={() => {
											handleAddFlightData("car");
										}}
										sx={{
											textTransform: "none",
											fontWeight: 600,
											borderRadius: "12px",
											borderColor: "rgba(99, 102, 241, 0.4)",
											color: "#6366F1",
											px: { xs: 2, sm: 3 },
											py: { xs: 1.25, sm: 1.5 },
											width: { xs: "100%", sm: "auto" },
											minWidth: { xs: "auto", sm: 180 },
											fontSize: { xs: "0.875rem", sm: "1rem" },
											backgroundColor: "#fff",
											transition: "all 0.2s ease",
											"&:hover": {
												borderColor: "#6366F1",
												backgroundColor: "rgba(99, 102, 241, 0.08)",
												boxShadow: "0 2px 8px rgba(99, 102, 241, 0.2)",
											},
										}}
									>
										Añadir coche/autobús
									</Button>

									<Button
										variant="outlined"
										startIcon={<TrainIcon sx={{ color: "#6366F1" }} />}
										onClick={() => {
											handleAddFlightData("train");
										}}
										sx={{
											textTransform: "none",
											fontWeight: 600,
											borderRadius: "12px",
											borderColor: "rgba(99, 102, 241, 0.4)",
											color: "#6366F1",
											px: { xs: 2, sm: 3 },
											py: { xs: 1.25, sm: 1.5 },
											width: { xs: "100%", sm: "auto" },
											minWidth: { xs: "auto", sm: 180 },
											fontSize: { xs: "0.875rem", sm: "1rem" },
											backgroundColor: "#fff",
											transition: "all 0.2s ease",
											"&:hover": {
												borderColor: "#6366F1",
												backgroundColor: "rgba(99, 102, 241, 0.08)",
												boxShadow: "0 2px 8px rgba(99, 102, 241, 0.2)",
											},
										}}
									>
										Añadir tren
									</Button>

									<Button
										variant="outlined"
										startIcon={<FlightTakeoffIcon sx={{ color: "#6366F1" }} />}
										onClick={() => {
											handleAddFlightData("flight");
										}}
										sx={{
											textTransform: "none",
											fontWeight: 600,
											borderRadius: "12px",
											borderColor: "rgba(99, 102, 241, 0.4)",
											color: "#6366F1",
											px: { xs: 2, sm: 3 },
											py: { xs: 1.25, sm: 1.5 },
											width: { xs: "100%", sm: "auto" },
											minWidth: { xs: "auto", sm: 180 },
											fontSize: { xs: "0.875rem", sm: "1rem" },
											backgroundColor: "#fff",
											transition: "all 0.2s ease",
											"&:hover": {
												borderColor: "#6366F1",
												backgroundColor: "rgba(99, 102, 241, 0.08)",
												boxShadow: "0 2px 8px rgba(99, 102, 241, 0.2)",
											},
										}}
									>
										Añadir vuelo
									</Button>
								</Box>
							</Box>
						) : (
							<Box
								sx={{
									display: "flex",
									flexDirection: { xs: "column", sm: "row" },
									justifyContent: "space-between",
									alignItems: { xs: "stretch", sm: "center" },
									gap: 2,
									mt: 3,
									pt: 3,
									borderTop: "1px solid rgba(0, 0, 0, 0.06)",
								}}
							>
								<Box
									sx={{
										display: "flex",
										flexDirection: { xs: "column", sm: "row" },
										gap: { xs: 1.5, sm: 1.5 },
										width: { xs: "100%", sm: "auto" },
									}}
								>
									{editedFlightData &&
										editedFlightData.length > 0 &&
										editedFlightData[editedFlightData.length - 1].type ===
											"car" && (
											<Button
												variant="outlined"
												startIcon={<DirectionsCarIcon />}
												onClick={() => {
													handleAddFlightData("car");
												}}
												sx={{
													textTransform: "none",
													fontWeight: 600,
													borderRadius: "12px",
													borderColor: "rgba(0, 0, 0, 0.12)",
													color: "#1a1a2e",
													"&:hover": {
														borderColor: "#6366F1",
														backgroundColor: "rgba(99, 102, 241, 0.04)",
													},
												}}
											>
												Añadir coche/autobús
											</Button>
										)}

									{editedFlightData &&
										editedFlightData.length > 0 &&
										editedFlightData[editedFlightData.length - 1].type ===
											"train" && (
											<Button
												variant="outlined"
												startIcon={<TrainIcon />}
												onClick={() => {
													handleAddFlightData("train");
												}}
												sx={{
													textTransform: "none",
													fontWeight: 600,
													borderRadius: "12px",
													borderColor: "rgba(0, 0, 0, 0.12)",
													color: "#1a1a2e",
													"&:hover": {
														borderColor: "#6366F1",
														backgroundColor: "rgba(99, 102, 241, 0.04)",
													},
												}}
											>
												Añadir tren
											</Button>
										)}

									{editedFlightData &&
										editedFlightData.length > 0 &&
										editedFlightData[editedFlightData.length - 1].type ===
											"flight" && (
											<Button
												variant="outlined"
												startIcon={<FlightTakeoffIcon />}
												onClick={() => {
													handleAddFlightData("flight");
												}}
												sx={{
													textTransform: "none",
													fontWeight: 600,
													borderRadius: "12px",
													borderColor: "rgba(0, 0, 0, 0.12)",
													color: "#1a1a2e",
													"&:hover": {
														borderColor: "#6366F1",
														backgroundColor: "rgba(99, 102, 241, 0.04)",
													},
												}}
											>
												Añadir vuelo
											</Button>
										)}
								</Box>

								<Button
									variant="contained"
									startIcon={<SaveIcon />}
									onClick={handleSaveFlightData}
									sx={{
										background:
											"linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
										color: "white",
										textTransform: "none",
										fontWeight: 600,
										borderRadius: "12px",
										px: { xs: 2, sm: 3 },
										py: { xs: 1.25, sm: 1 },
										width: { xs: "100%", sm: "auto" },
										fontSize: { xs: "0.875rem", sm: "1rem" },
										boxShadow: "0 4px 16px rgba(99, 102, 241, 0.35)",
										"&:hover": {
											background:
												"linear-gradient(135deg, #6366F1 0%, #8B5CF6 100%)",
											boxShadow: "0 6px 20px rgba(99, 102, 241, 0.45)",
											transform: "translateY(-2px)",
										},
									}}
								>
									Guardar Cambios
								</Button>
							</Box>
						)}
					</Box>
				}
			/>
		</div>
	);
};

export default Flight;
